"use client";

import { useState } from "react";

export default function FilterGroup({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="asian-bucket-filter-group">
      <button
        type="button"
        className="asian-bucket-filter-title"
        onClick={() => setOpen((current) => !current)}
      >
        <h2>{title}</h2>

        <span className={`asian-bucket-filter-arrow ${open ? "is-open" : ""}`}>
          ⌃
        </span>
      </button>

      {open && children}
    </section>
  );
}
